import { NavLink } from 'react-router-dom';

import { AllocabLogo } from './AllocabLogo';
import { FEATURES } from '../../constants';
import { useAccount } from '../../contexts/AccountContext';
import type { Domain } from '../../domain/access';

interface NavItem {
  to: string;
  label: string;
  domain: Domain;
  end?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Tableau de bord', domain: 'trips', end: true },
  { to: '/incidents', label: 'Incidents', domain: 'incidents' },
  { to: '/performance', label: 'Performance', domain: 'performance' },
  { to: '/invoices', label: 'Facturation', domain: 'invoicing' },
  ...(FEATURES.lostFound ? [{ to: '/lost-found', label: 'Objets trouvés', domain: 'trips' as const }] : []),
  { to: '/admin', label: 'Administration', domain: 'admin' },
];

export const Sidebar = () => {
  const { config, me, can } = useAccount();
  const visibleItems = NAV_ITEMS.filter(item => can(item.domain));

  return (
    <aside className="w-[240px] shrink-0 border-r border-extranet-border bg-extranet-card flex flex-col">
      <div className="px-6 py-5 border-b border-extranet-border">
        <div className="flex items-baseline gap-2">
          <AllocabLogo className="h-5 w-auto text-extranet-text-primary" />
          <span className="font-mono text-[11px] uppercase tracking-wide text-extranet-text-tertiary">Extranet</span>
        </div>
        <p className="text-xs text-extranet-text-tertiary mt-1.5">{config.name}</p>
      </div>

      <nav className="flex-1 px-3 py-4 flex flex-col gap-0.5">
        {visibleItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                'px-3 py-2 rounded-md text-sm transition-colors duration-100',
                isActive
                  ? 'bg-extranet-card-muted text-extranet-text-primary font-medium'
                  : 'text-extranet-text-secondary hover:bg-extranet-card-muted hover:text-extranet-text-primary',
              ].join(' ')
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="px-6 py-4 border-t border-extranet-border flex flex-col gap-1">
        <p className="text-xs text-extranet-text-secondary truncate" title={me.fullName}>
          {me.fullName}
        </p>
        <p className="text-extranet-text-tertiary text-xs">v0.1.0</p>
      </div>
    </aside>
  );
};
